import {ChangeDetectorRef, Component, Input, NgZone, OnDestroy, OnInit} from '@angular/core';
import {Subscription} from 'rxjs';
import {AppStateService} from '../../providers/app-state.service';
import {map, switchMap, take} from 'rxjs/operators';
import {ActivatedRoute, Router} from '@angular/router';
import {CommonUtils} from '../../utils/common';
import {AuthService} from '../../providers/auth.service';
import {GenericNotification} from '../../models/notification/generic-notification.model';
import {PopoverController} from '@ionic/angular';
import {NotificationsPopoverComponent} from '../notifications-popover/notifications-popover.component';
import {User} from "../../models/user.model";
import {UserService} from "../../providers/user.service";

@Component({
  selector: 'app-page-top-toolbar',
  templateUrl: './page-top-toolbar.component.html',
  styleUrls: ['./page-top-toolbar.component.scss'],
})
export class PageTopToolbarComponent implements OnInit, OnDestroy {
  @Input() title: string;
  @Input() fullToolbar: boolean;
  @Input() backBtnCommands: any[];

  user: User;
  private userSub: Subscription;

  public isBusy: boolean;
  private isBusySub: Subscription;

  public unreadNotifications = 0;
  private notifications: GenericNotification[];
  private notificationsSub: Subscription;

  public isConnected: boolean;
  private isConnectedSub: Subscription;

  constructor(
    private appStateService: AppStateService,
    private router: Router,
    private route: ActivatedRoute,
    public commonUtils : CommonUtils,
    private authService: AuthService,
    private popoverController: PopoverController,
    private cdr: ChangeDetectorRef,
    private userService: UserService
  ) { }

  ngOnInit() {
    if (this.fullToolbar === undefined) this.fullToolbar = true;

    this.isBusySub = this.appStateService.isBusySubject.subscribe(isBusy => {
      this.isBusy = isBusy;
      this.cdr.detectChanges();
    });
    this.isConnectedSub = this.appStateService.networkStatusSubject.pipe(map(status => {
      return status.connected;
    })).subscribe(isConnected => {
      this.isConnected = isConnected;
      this.cdr.detectChanges();
    });
    this.notificationsSub = this.appStateService.notificationsSubject.subscribe(notifications => {
      this.notifications = notifications;
      this.unreadNotifications = this.notifications.filter(notification => !notification.wasSeen)?.length;
      this.appStateService.requestScreenRefresh();
    });

    this.userSub = this.userService.getUser().subscribe(it => {
      this.user = it;
    });
  }

  goBack() {
    console.log(this.backBtnCommands);
    if (this.backBtnCommands) {
      this.router.navigate(this.backBtnCommands);
    }
  }

  logout() {
    this.commonUtils.presentYesNoActionSheet('Czy na pewno chcesz się wylogować?', 'Tak', 'Nie', 'log-out-outline', 'close', () => {
      this.router.navigate(['signin']).then(() =>{
        this.authService.logout();
      });
    }, undefined);
  }

  ngOnDestroy() {
    if (this.isBusySub) { this.isBusySub.unsubscribe(); }
    if (this.isConnectedSub) { this.isConnectedSub.unsubscribe(); }
    if (this.notificationsSub) { this.notificationsSub.unsubscribe(); }
    if (this.userSub) { this.userSub.unsubscribe(); }

  }

  async showNotifications(ev: any) {
    if (this.notifications && this.notifications.length > 0) {
      const notificationsObj = this.commonUtils.bestTypedArrayCopyEver<GenericNotification, GenericNotification[]>(new GenericNotification(), [], this.notifications);
      const popover = await this.popoverController.create({
        component: NotificationsPopoverComponent,
        event: ev,
        componentProps: { notifications: notificationsObj }
      });

      return popover.present();
    }
  }
}
